import { Reveal } from "@/lib/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Honest diagnostics, always",
    text: "We never sell you a new boiler when a £40 part brings yours back to full health. You get the truth, a photo of the fault, and options — not a sales pitch.",
  },
  {
    num: "02",
    title: "The price you see is the price you pay",
    text: "Fixed prices published online, paid securely by card. No call-out fees buried in the small print, no 'while we were in there' surprises on the invoice.",
  },
  {
    num: "03",
    title: "Gas Safe registered, locally rooted",
    text: "Every Teign Gas engineer carries verifiable Gas Safe ID and knows Teignbridge's housing stock inside out — from 1930s semis to new-build estates.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-20 lg:py-28 bg-[#0C0C0C] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-torch font-semibold">06 / The Teign Gas way</p>
        </Reveal>
        <div className="mt-12 space-y-0">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline py-10 border-t border-neutral-800 last:border-b hover:bg-white/[0.015] transition-colors px-2 sm:px-4">
                <span className="md:col-span-2 font-mono font-bold text-5xl lg:text-6xl text-torch/15 group-hover:text-torch/50 transition-colors">
                  {c.num}
                </span>
                <h3 className="md:col-span-4 font-display font-bold text-2xl lg:text-3xl text-white uppercase tracking-tight">
                  {c.title}
                </h3>
                <p className="md:col-span-6 text-neutral-400 leading-relaxed text-sm sm:text-base">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
